import * as React from 'react';

import { requestGet } from '../../../../modules/request';
import {
  Tooltip,
  getExtraSmallColoredIconForActivityClassification,
  safeParseHtml,
} from '../../../Shared/index';

export const activityColumnMaxWidth = '410px';
export const rowSectionTooltipClassName = 'tooltip-section review-activities-data-table-section';

export const toolTableHeader = {
  name: 'Tool',
  attribute: 'tool',
  width: '50px',
  headerClassName: 'center-content',
  rowSectionClassName: `${rowSectionTooltipClassName} center-content`,
  noTooltip: true
}

export const activityTableHeader = {
  name: 'Activity',
  attribute: 'activity',
  rowSectionClassName: rowSectionTooltipClassName,
  width: activityColumnMaxWidth
}

export const publishDateTableHeader = {
  ariaLabel: 'Publish Date',
  name: (
    <Tooltip
      tooltipText="When you schedule an activity, it is displayed in your dashboard, but it is hidden from a student until the publish date."
      tooltipTriggerText={<span className="publish-date-header">Publish Date</span>}
    />
  ),
  attribute: 'publishDatePicker',
  width: '148px',
  headerClassName: 'publish-date-header-container',
  rowSectionClassName: 'datetime-picker'
}

export const previouslyAssignedTableHeader = {
  name: 'Previously Assigned',
  attribute: 'previouslyAssigned',
  width: '90px',
  headerClassName: 'allow-wrap center-content previously-assigned-section',
  rowSectionClassName: `${rowSectionTooltipClassName} center-content previously-assigned-section`,
  noTooltip: true
}

export const renderToolIcon = (activity) => (
  <Tooltip
    tooltipMaxWidth={200}
    tooltipText={`<h5 class="tool-name">${activity.activity_classification.alias}</h5><p class="activity-or-tool-description tool-description">${activity.activity_classification.description}</p>`}
    tooltipTriggerText={getExtraSmallColoredIconForActivityClassification(activity.activity_classification.id)}
  />
)

export const renderActivityName = (activity) => (
  <Tooltip
    tooltipMaxWidth={466}
    tooltipText={`<h5>${activity.name}</h5><p><b>Tool:</b> <span>${activity.activity_classification.alias}</span></p>${activity.readability_grade_level ? `<p><b>Readability score:</b> <span>${activity.readability_grade_level}</span></p>` : ''}<p class="activity-or-tool-description">${activity.description}</p>`}
    tooltipTriggerText={safeParseHtml(activity.name)}
    tooltipTriggerTextClass="activity-name"
    tooltipTriggerTextStyle={{ maxWidth: activityColumnMaxWidth }}
  />
)

export const requestPreviouslyAssignedActivityData = (activityIds, callback) => {
  requestGet(`${window.postbuildEnv.DEFAULT_URL}/teachers/unit_templates/previously_assigned_activities?activity_ids=${JSON.stringify(activityIds)}`, (response) => {
    if (response.previously_assigned_activity_data && Object.keys(response.previously_assigned_activity_data).length) {
      callback(response.previously_assigned_activity_data)
    }
  })
}
